import { NAME } from './constants';

export const LOAD_REFERENCE_DATA = `${NAME}/LOAD_REFERENCE_DATA`;
export const LOAD_FAIL = `${NAME}/LOAD_FAIL`;
